<template>
	<div>
		<div class="modal-wrapper">
			<div class="modal">
				<div class="modal-content">
					<a href="#" class="close-button" @click.stop.prevent="close"
						><i class="icon bis-close" />
					</a>
					<h1 class="header">
						AVOID ANY LAG
					</h1>
					<form id="form" @submit.prevent="handleSubmit">
						<p class="paragraph">
							Improve your connection by subscribing to Bohemia
							Interactive’s Newsletter. Stay ahead of the game by
							receiving up-to-date intel on the latest news from
							Bohemia, and be notified about any upcoming sales in
							our store.
						</p>
						<div class="form-input-wrapper">
							<input
								id="email"
								v-model="email"
								name="email"
								class="email-input"
								:class="{
									error:
										emailErrors.length || emailErrors.format
								}"
								type="text"
								placeholder="example@email.com"
							/>
							<span
								v-if="emailErrors.length"
								class="form-group__message"
								>Field is required</span
							>
							<span
								v-if="emailErrors.format"
								class="form-group__message"
								>Please, enter valid email.</span
							>
						</div>
						<div class="form-input-wrapper checkbox-wrapper">
							<input
								id="newsletter_checkbox"
								v-model="agreement"
								type="checkbox"
								class="checkbox"
							/>
							<label for="newsletter_checkbox"
								><a
									href="https://www.bohemia.net/company/careers/terms"
									class="gdpr"
								>
									Agree to our Terms and Conditions and our
									latest GDPR update</a
								></label
							>
							<div class="divider--sm" />
							<span
								v-if="agreementErrors.checked"
								class="form-group__message"
								>You need to accept our agreement</span
							>
						</div>
						<div class="subscribe-button">
							<bi-button type="rounded" @click="subscribe">
								<span class="subscribe-text">Subscribe</span>
							</bi-button>
						</div>
					</form>
				</div>
			</div>
			<div class="modal-backdrop" @click.stop="close" />
		</div>
	</div>
</template>

<script>
import BiButton from "./Button";

export default {
	name: "BiModalWindow",
	components: { BiButton },
	data() {
		return {
			gdpr_accept: false,
			email: "",
			agreement: false,
			emailErrors: {
				length: false,
				format: false
			},
			agreementErrors: {
				checked: false
			}
		};
	},
	methods: {
		close() {
			this.$emit("close");
		},
		gdprDecline() {
			this.$emit("decline");
		},
		gdprAccept() {
			this.gdpr_accept = true;
			this.close();
		},
		subscribe() {
			if (this.email && this.email.length > 0) {
				this.emailErrors.length = false;
				let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				let isEmail = re.test(String(this.email).toLowerCase());
				if (isEmail) {
					this.emailErrors.format = false;
					if (this.agreement) {
						this.agreementErrors.checked = false;
						this.$emit("subscribe");
						this.close();
					} else {
						this.agreementErrors.checked = true;
					}
				} else {
					this.emailErrors.format = true;
				}
			} else {
				this.emailErrors.length = true;
			}
		},
		handleSubmit() {
			this.close();
		}
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/vars";
@import "../../assets/scss/typography";

.header {
	font-size: 50px;
	font-weight: 800;
	font-family: $montserrat;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: $cod-gray;
	text-align: center;
	margin-bottom: 45px;
}

.paragraph {
	font-family: $inter-ui;
	color: $mine-shaft;
	letter-spacing: 0.12px;
	font-size: 16px;
	font-weight: 400;
	line-height: 28px;
	text-align: center;
}

.subscribe-button {
	display: flex;
	justify-content: center;

	.subscribe-text {
		width: 200px;
		display: block;
		position: relative;
	}
}

.form-input-wrapper {
	padding-bottom: 20px;
	padding-top: 20px;
}

.checkbox-wrapper {
	text-align: center;
}

.newsletter-form {
	padding: 1.4em;
	border-color: #505050;
}

.email-input {
	width: 100%;
	text-align: center;
	padding: 15px;
	border: 1px solid $cod-gray;
	border-radius: 4px;
}

.form-group__message {
	color: #c32121;
	font-size: 12px;
}

.gdpr {
	color: $cod-gray;

	&:active {
		color: $cod-gray;
	}

	&:visited {
		color: $cod-gray;
	}
}

.error {
	border-color: red;
	background: #fdd;
}

.error:focus {
	outline-color: #f99;
}

.valid {
	border-color: #70c165;
}

.valid:focus {
	outline-color: #70c165;
}

.close-button {
	background-color: #000;
	color: #fff;
	padding: 0;
	padding-top: 5px;
	padding-left: 5px;
	padding-right: 5px;
	position: absolute;
	text-decoration: none;
	font-size: 48px;
	line-height: 45px;
	top: -8px;
	right: -8px;
}

.modal-backdrop {
	position: fixed;
	z-index: 102;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.6);
}

.modal-wrapper {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 101;
}

.modal {
	max-width: 840px;
	position: fixed;
	z-index: 103;
	background-color: #f7f7f7;
	overflow-x: auto;
	display: flex;
	flex-direction: column;
	margin-right: 10px;
	margin-left: 10px;
	padding: 1em;

	.modal-content {
		position: relative;
		border: 8px solid #000;
		padding: 4em;
		@media (max-width: $xs) {
			padding: 1em;
		}

		h1 {
			margin-top: 50px;
			text-transform: uppercase;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/coppiedFooter/Modal-Window.vue